__turbopack_context__.v({
  "heading": "Manifesto-module__ElXEqG__heading",
  "imageWrap": "Manifesto-module__ElXEqG__imageWrap",
  "inner": "Manifesto-module__ElXEqG__inner",
  "manifestoImage": "Manifesto-module__ElXEqG__manifestoImage",
  "mediaFrame": "Manifesto-module__ElXEqG__mediaFrame",
  "section": "Manifesto-module__ElXEqG__section",
  "titleDim": "Manifesto-module__ElXEqG__titleDim",
  "titleLine": "Manifesto-module__ElXEqG__titleLine",
});
